module.exports = __webpack_public_path__ + "img/emo_45.a01daa8b.png";